import { TNutritionKey } from 'components/nutrition/item-nutrition/item-nutrition';

const units: Record<TNutritionKey, string> = {
  calories: 'kcal',
  carbohydrates: 'g',
  cholesterol: 'mg',
  fat: 'g',
  fiber: 'g',
  proteins: 'g',
  salt: 'g',
  saturatedFat: 'g',
  sodium: 'mg',
  sugar: 'g',
  transFat: 'g',
  weight: 'g',
};

export const getUnitForNutrient = (nutrient: TNutritionKey): string => units[nutrient];
